import { useTranslation } from 'react-i18next';
import { useTitle } from 'react-use';

const usePageTitle = (title?: string) => {
    const { t } = useTranslation();

    const createPageTitle = (title?: string): string => {
        if (!title) {
            return t('meta.title');
        }

        return `${title} | ${t('meta.title')}`;
    };

    useTitle(createPageTitle(title));
};

export default usePageTitle;
